import React from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

export default function ContentUnavailable() {
    const history = useHistory();

    return (
        <div className="content-unavailable text-center py-5">
            <h4 className="mb-3 text-dark">Content unavailable</h4>
            <p className="text-muted mb-4 mx-auto content-unavailable__description">
                This content is no longer available. It may have been removed, deleted, or is no longer accessible.
            </p>
            <Button variant="outline-primary" onClick={() => history.goBack()}>
                Back
            </Button>
        </div>
    );
}
